import { all, takeEvery } from "redux-saga/effects";
import { actionTypes as maintainedValuesActionTypes } from "./reducer";
import { getMaintainedValues as getMaintainedValuesService } from "./service";
import processAction from "../../utils/processAction";

function* getMaintainedValues(action) {
  yield processAction({
    ...action,
    service: getMaintainedValuesService,
    success: maintainedValuesActionTypes.GET_MAINTAINED_VALUES_SUCCESS,
    failed: maintainedValuesActionTypes.GET_MAINTAINED_VALUES_FAILED
  });
}

function* watcher() {
  yield all([
    takeEvery(
      maintainedValuesActionTypes.GET_MAINTAINED_VALUES,
      getMaintainedValues
    )
  ]);
}

export default [watcher()];
